<button class="publish-button-invalid">
  <span *ngIf="buttonPlus">+&nbsp;&nbsp;&nbsp;</span>{{buttonText}}
</button>